import { FlowRunAnalyticEventCategory } from 'flow-schema';

import { type api, isDefined, isTruthy } from 'common';

const analyticEventCategoryToDisplayName: Record<
  Exclude<FlowRunAnalyticEventCategory, FlowRunAnalyticEventCategory.Custom>,
  string
> = {
  [FlowRunAnalyticEventCategory.Authorizations]: 'Authorizations',
  [FlowRunAnalyticEventCategory.ReferralTranscription]: 'Referral Transcription',
  [FlowRunAnalyticEventCategory.IntakePayments]: 'Intake/Payments',
  [FlowRunAnalyticEventCategory.ReferralScheduling]: 'Referral Scheduling',
  [FlowRunAnalyticEventCategory.CareGaps]: 'Care Gaps',
  [FlowRunAnalyticEventCategory.HccSuspecting]: 'HCC Suspecting',
  [FlowRunAnalyticEventCategory.OutboundScheduling]: 'Outbound Scheduling',
};

export function getEventCategoryDisplayName(eventCategory?: string | null) {
  if (!isDefined(eventCategory)) {
    return '';
  }

  return (
    analyticEventCategoryToDisplayName[
      eventCategory as Exclude<FlowRunAnalyticEventCategory, FlowRunAnalyticEventCategory.Custom>
    ] ?? eventCategory
  );
}

export function getAllCustomAttributeKeys(
  flowDefinition: api.FlowDefinition.FlowDefinitionWithFlow
): Set<string> {
  const customAttributeKeys = new Set<string>();

  flowDefinition.data.blocks.forEach((block) => {
    if (isTruthy(block.events?.length)) {
      block.events.forEach((event) => {
        event.customAttributes?.forEach((attr) => {
          if (isDefined(attr.key)) {
            customAttributeKeys.add(attr.key);
          }
        });
      });
    }
  });

  return customAttributeKeys;
}
